// De widget staat in een iframe op de site van de klant en praat met de pagina eromheen: hoe hoog
// hij moet worden, waar hij moet staan, en waar de gast naartoe moet voor het betalen.
//
// Dat ging met window.parent.postMessage(..., "*"). Die ster betekent "elke pagina mag dit lezen".
// Staat de widget op een pagina die daar iets mee wil, dan leest die pagina mee wat er over de
// reservering heen en weer gaat. Er is geen reden voor die ster: we weten welke pagina ons insluit.
//
// Hoe we dat weten, in deze volgorde:
//
//   1. De pagina geeft het zelf mee in het adres van de iframe (?parentOrigin=https://klant.nl).
//      Dat is de zekerste, en het is wat de insluitcode zou moeten doen.
//   2. document.referrer. Dat is het adres van de pagina die ons insluit; de browser vult dat zelf
//      in en een pagina kan het niet vervalsen.
//   3. Staan we niet in een iframe, dan is het onze eigen pagina.
//   4. Weten we het echt niet -- de klant stuurt geen referrer mee -- dan valt hij terug op de ster.
//      Dat is niet mooi, maar een widget die geen hoogte meer kan doorgeven is stuk, en dat is
//      erger. In de praktijk is dit zeldzaam; punt 1 en 2 dekken vrijwel alles.

let onthouden = null;

function afleiden() {
    if (typeof window === 'undefined') return '*';

    // 1. De pagina zegt het zelf.
    try {
        const gegeven = new URLSearchParams(window.location.search).get('parentOrigin');

        if (gegeven) {
            const adres = new URL(gegeven);

            if (adres.protocol === 'http:' || adres.protocol === 'https:') return adres.origin;
        }
    }
    catch { /* een onleesbaar adres slaan we over */ }

    // 2. De browser zegt het.
    try {
        if (document.referrer) {
            const adres = new URL(document.referrer);

            if (adres.protocol === 'http:' || adres.protocol === 'https:') return adres.origin;
        }
    }
    catch { /* idem */ }

    // 3. Geen iframe: onze eigen pagina.
    try {
        if (window.parent === window) return window.location.origin;
    }
    catch { /* bij een andere herkomst mag dit gooien */ }

    // 4. Onbekend.
    return '*';
}

/**
 * Het adres van de pagina waar de widget in staat.
 *
 * @returns {string} Een herkomst als https://klant.nl, of "*" als hij niet te bepalen is.
 */
export function ouderAdres() {
    if (onthouden === null) onthouden = afleiden();

    return onthouden;
}

/**
 * Stuurt een bericht naar de pagina waar de widget in staat.
 *
 * @param {object} bericht Wat er verstuurd wordt.
 */
export function naarOuder(bericht) {
    if (typeof window === 'undefined') return;

    window.parent.postMessage(metBalk(bericht), ouderAdres());
}

/**
 * De balk "Testmodus - nog niet live" (components/Testmodus.jsx) staat boven de widget, buiten wat de schermen meten
 * (stepContentRef, de wortel van de widget). Een hoogte in px kwam daardoor steeds die balk te kort: op de eigen site was
 * het venster 502px en viel de onderkant van elke stap weg (proef 990502, 10-10-2026). Hier komt de balk erbij.
 * Een hoogte als "100vh" blijft zoals hij is.
 *
 * @param {object} bericht Wat er verstuurd wordt.
 * @returns {object} Hetzelfde bericht, met de balk in de hoogte.
 */
export function metBalk(bericht) {
    const hoogte = bericht?.reservationIframeHeight;
    if (typeof hoogte !== 'string' || !/^\d+(\.\d+)?px$/.test(hoogte.trim())) return bericht;
    if (typeof document === 'undefined') return bericht;

    const balk = document.querySelector('[data-jm-testbalk]');
    const extra = balk ? Math.ceil(balk.getBoundingClientRect().height) : 0;
    if (extra <= 0) return bericht;

    return { ...bericht, reservationIframeHeight: `${Math.ceil(parseFloat(hoogte)) + extra}px` };
}

/**
 * Alleen voor de tegenproef: vergeet wat er eerder is afgeleid.
 */
export function vergeetOuderAdres() {
    onthouden = null;
}
